import { HTTP } from '@/http-common'

function addPrintOrder (printOrderData) {
  let data = JSON.stringify(printOrderData)

  return HTTP.post('/print-orders', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

export { addPrintOrder }



// WEBPACK FOOTER //
// ./src/services/print_order.service.js